import NotFound from './NotFound';

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/not-found/index.js